import { put, select, takeLatest } from 'redux-saga/effects'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { IItem, ITimelineState } from '../store/timeline.types'
import { getAddMedicationAdministeredSelector } from '../../addMedicationAdministered/selectors'
import { IAddMedicationAdministeredState } from '../../addMedicationAdministered/store/addMedicationAdministered.types'
import { TimelineConstants } from '../store/timeline.constants'
import { TabConstants } from '../../../components/tabs/Tabs.constants'

export function* addMedicationAdministeredItem() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { items } = timeline
  const addMedicationAdministeredState: IAddMedicationAdministeredState = yield select(
    getAddMedicationAdministeredSelector
  )
  const { pta, key, assessedBy, addMedicationAdministeredData, time, date, addToTimeline, comments, isEkgImport } =
    addMedicationAdministeredState

  if (addToTimeline) {
    const clientCorrelationId = `patient.medicationAdministeredStateList_${key}`
    const dateTime = new Date(date || 0)
    if (time) {
      if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
      dateTime.setMinutes(+time.split(':')[1])
      dateTime.setHours(+time.split(':')[0])
    }
    const index = items.findIndex((item) => item.key === addMedicationAdministeredState.key)
    const item: IItem = {
      key: key,
      itemType: 'Medications',
      event: 'Medication Administered',
      grid: true,
      labelHeaderFlag: pta ? 'PTA' : '',
      labelHeader: time,
      subHeader: date,
      eventSubHeader: '',
      rowActionType: TimelineConstants.SET_ADD_MEDICATION_ADMINISTERED_ITEM,
      defaultHref: TabConstants.ADD_MEDICATIONS_ADMINISTERED,
      date: dateTime,
      clientCorrelationId,
      ...(isEkgImport && { isEkgImport: isEkgImport }),
    }
    addMedicationAdministeredData.map((addMedicationAdministered) => {
      const { medication, dose, doseUnit, route } = addMedicationAdministered
      const doseLabel = doseUnit?.name || ''
      const routeLabel = route?.name || ''
      const performedByLabel = assessedBy?.name || ''
      item.eventSubHeader =
        item.eventSubHeader + `${medication?.name} By ${performedByLabel}, ${dose} ${doseLabel}, Via ${routeLabel}, `
    })
    item.eventSubHeader = item.eventSubHeader + `Comments: ${comments}`
    if (index !== -1) {
      items[index] = item
    } else {
      items.push(item)
    }
    yield put(setActivityLog(items))
    yield put(saveTimelineItems())
  }
}
export function* addMedicationAdministeredItemSaga() {
  yield takeLatest([TimelineConstants.ADD_MEDICATION_ADMINISTERED_ITEM], addMedicationAdministeredItem)
}
